import { Injectable } from '@angular/core';

const STORAGE_KEY_PREFIX = 'to-ng.pagesize.';

@Injectable({ providedIn: 'root' })
export class PageSizePreferenceService {
  /**
   * Der ganze `localStorage`-Zugriff ist gekapselt, weil er in privaten Browser-Sessions,
   * bei blockierten Cookies oder unter Unternehmensrichtlinien schon beim reinen Lesen
   * werfen kann (SecurityError). Diese Methode wird im Feld-Initialisierer der Uebersichts-
   * komponenten aufgerufen — eine geworfene Exception dort verhindert die Erzeugung der
   * Komponente und laesst die Seite leer. Der Voreinstellungs-Fallback ist die richtige
   * Antwort, kein Seitenausfall.
   */
  get(route: string, allowed: readonly number[], defaultSize: number): number {
    let raw: string | null;
    try {
      raw = localStorage.getItem(STORAGE_KEY_PREFIX + route);
    } catch {
      return defaultSize;
    }
    if (raw === null || raw === '') {
      return defaultSize;
    }
    const parsed = Number(raw);
    if (!Number.isFinite(parsed) || !allowed.includes(parsed)) {
      return defaultSize;
    }
    return parsed;
  }

  /**
   * Symmetrisch zu `get`: nur erlaubte Werte werden persistiert, damit ein kuenftiger Leser
   * sich auf den gespeicherten Inhalt verlassen kann. Und `setItem` selbst wird gekapselt,
   * weil ein `QuotaExceededError` oder ein verweigerter Speicher (siehe `get`) das UI nicht
   * zum Absturz bringen darf — die Auswahl im UI bleibt trotzdem gueltig.
   */
  set(route: string, size: number, allowed: readonly number[]): void {
    if (!allowed.includes(size)) {
      return;
    }
    try {
      localStorage.setItem(STORAGE_KEY_PREFIX + route, String(size));
    } catch {
      // Nicht speichern zu koennen darf die Auswahl nicht verhindern.
    }
  }
}
